export const sectionVisibilityThreshold: number = 0.5;
